import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import AssignmentUnitsResource from "@ane/exp-data/lib/resources/expapiunified/AssignmentUnits.resource";
import { replaceAssignmentUnit } from "../../common/epics/actions.js";
import { prefix } from "./constants.js";
const archiveUnarchiveAssignmentUnitEpicReducerArgs = {
  actionPrefix: `${prefix}/ARCHIVEUNARCHIVEV2`,
  reduxKeyNested: () => ["archiveUnarchiveResult"],
  loadResource: (inputPayload) => AssignmentUnitsResource.updateAssignmentUnit(inputPayload.workspaceId, inputPayload.id, inputPayload.data),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload) => [
    replaceAssignmentUnit(outputPayload)
  ]
};
const archiveUnarchiveAssignmentUnitEpicReducer = loadResourcesUtils(archiveUnarchiveAssignmentUnitEpicReducerArgs);
export {
  archiveUnarchiveAssignmentUnitEpicReducer
};
//# sourceMappingURL=epicsV2.js.map
